module.exports = __webpack_public_path__ + "static/easy-2cf3a8bb8d8b664b4ddadd934ba1db58.jpg";